import ACE from 'assets/cameras/Ace.svg';
import ONE from 'assets/cameras/One.svg';

export { ACE, ONE };
